import React, { useEffect, useState, useContext } from "react";
import "../styles/manageUsers.css";
import LoadingIcon from "../images/Loading_icon.gif";
import BlackListedExpertRow from "../components/BlackListedExperts/BlackListedExpertRow";
// import { UserContext } from "../contexts/UserContext";
import { UrlContext } from "../contexts/UrlContext";

export default function BlackListedExperts() {
  useEffect(() => {
    document.title = "Blacklisted Experts";
  }, []);
  const { API_URL } = useContext(UrlContext);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
//   const { userData, userError, adminUser } = useContext(UserContext);
  const [showSelectImage, setShowSelectImage] = useState(false);
  const [dataForImageUpload, setDataForImageUpload] = useState(null);

  // Pagination State
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  useEffect(() => {
    const url = `${API_URL}get-all-blackListedExpert`;
    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        console.log(data)
        setData(data.blacklistedexperts);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  // Calculate Pagination
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = data ? data.slice(indexOfFirstRow, indexOfLastRow) : [];

  const totalPages = data ? Math.ceil(data.length / rowsPerPage) : 1;

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <>
      <div className="container-div">
        <div className="delete-user-div">
          <h3><strong>Blacklisted Experts</strong></h3>

          {loading ? (
            <img
              className="delete-user-loading"
              src={LoadingIcon}
              alt="Loading..."
            />
          ) : (
            <>
              <table className="table delete-user-table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Delete</th>
                  </tr>
                </thead>

                <tbody>
                  {currentRows.map((expert, index) => (
                    <BlackListedExpertRow
                      expert={expert}
                      key={index}
                    />
                  ))}
                </tbody>
              </table>

              {/* Pagination Controls */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: "20px",
                }}
              > 
              <input
                    onClick={handlePrevPage}
                    disabled={currentPage === 1}
                    type="button"
                    className="action-button-previous"
                    style={{
                        width: '100px',
                        background: '#616161',
                        color: 'white',
                        border: '0',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        padding: '10px 5px',
                        margin: '10px 5px 10px 0px',
                        opacity: currentPage === 1 ? 0.5 : 1,
                      }}
    
                    defaultValue="Previous"
                />
                <span
                  style={{
                    fontSize: "16px",
                    fontWeight: "bold",
                    margin: "0 10px",
                  }}
                >
                  Page {currentPage} of {totalPages}
                </span>
                <input
                    onClick={handleNextPage}
                    disabled={currentPage === totalPages}
                    style={{
                        width: '100px',
                        background:'#365561',
                        color: 'white',
                        border: '0',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        padding: '10px 5px',
                        margin: '10px 0px 10px 5px',
                        opacity: currentPage === totalPages ? 0.5 : 1,
                    }}      
                    type="button"
                    className="action-button-next"
                    defaultValue="Next"
                />
              </div>

            </>
          )}
        </div>
      </div>
    </>
  );
}
